WiseMetering.Views.InfraspeakIntegrationsTable = WiseMetering.Views.TableIndex.extend({
    icon: 'integrations',
    name: () => 'Infraspeak',

    createTable: function() {
        this.collection = this.model.integrations();

        this.table = new WiseMetering.Views.Table({
            id: 'integrations',
            collection: this.collection,
            disableSelect: !WiseMetering.currentUser.isSuperUser(),
            modelSerializer: model => {
                let
                    color = 'orange',
                    state = model.get('state');

                if (state === 'active') {
                    color = 'green';
                }

                return {
                    assetsNumber: model.get('assets').length,
                    siteName: model.site()?.get('name'),
                    configurationName: WiseMetering.integrationConfigurations.get(model.get('configuration_id')).get('name'),
                    id: model.id,
                    indicator: WiseMetering.indicators.get(model.get('indicator_id')).get('name'),
                    name: model.get('name'),
                    lastRunAt: model.get('last_run_at') ? WiseMetering.utils.formatDate(model.get('last_run_at')) : '-',
                    updatedAt: WiseMetering.utils.formatDate(model.get('updated_at')),
                    state: { color, state }
                };
            },
            columns: {
                state: {
                    mRender: ({ color, state }) => JST['templates/ui/components/circle']({
                        color: WiseMetering.SemaphorColors[color],
                        title: state.capitalize()
                    }),
                    sWidth: '20px'
                },
                name: i18next.t('common.name'),
                indicator: i18next.t('glossary.indicator'),
                siteName: i18next.t('glossary.site'),
                configurationName: i18next.t('glossary.configuration'),
                assetsNumber: i18next.t('integrations.integrated_assets'),
                lastRunAt: i18next.t('integrations.last_run_at'),
                updatedAt: i18next.t('glossary.last_change')
            },
            toolbar_actions: {
                new: {
                    label: i18next.t('ui.actions.new'),
                    permission: 'superuser',
                    view_call: () => new WiseMetering.Views.NewInfraspeakIntegration({
                        collection: WiseMetering.integrations,
                        license: this.model,
                        model: new WiseMetering.Model.Integration({ license_id: this.model.id })
                    })
                },
                edit: {
                    label: i18next.t('ui.actions.edit'),
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.EditInfraspeakIntegration({ model })
                },
                show: {
                    label: i18next.t('ui.actions.show'),
                    view_call: model => new WiseMetering.Views.ShowInfraspeakIntegration({ model })
                },
                disable: {
                    icon: 'disable',
                    label: i18next.t('ui.actions.disable'),
                    permission: 'superuser',
                    view_call: model => {
                        if (model.get('state') !== 'active') {
                            return;
                        }

                        new WiseMetering.Views.DisableIntegration({ model });
                    }
                },
                enable: {
                    icon: 'enable',
                    label: i18next.t('ui.actions.enable'),
                    permission: 'superuser',
                    view_call: model => {
                        if (model.get('state') === 'active') {
                            return;
                        }

                        new WiseMetering.Views.EnableIntegration({ model });
                    }
                },
                delete: {
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.Modal.DestroyExtraConfirmation({
                        model,
                        title: () => i18next.t('modal.title.integrations.destroy')
                    })
                }
            }
        });

        $(this.body.el).html(this.table.el);
    },

    onClose: function() {
        this.stopListening(WiseMetering.integrations);

        if (this.table && this.table.remove && typeof (this.table.remove) === 'function') {
            this.table.remove();
        }
    },

    onShow: function() {
        this.listenTo(WiseMetering.integrations, 'remove add change', this.createTable.bind(this));

        this.createTable();
    }
});
